type AnalyticsPrimitive = string | number | boolean;
type AnalyticsParams = Record<string, AnalyticsPrimitive | null | undefined>;
const DEFAULT_GA_MEASUREMENT_ID = 'G-797EW4SNQ1';
const GA_SCRIPT_ID = 'ga4-gtag-script';
let didInitAnalytics = false;

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: any[]) => void;
  }
}

const sanitizeParams = (params: AnalyticsParams): Record<string, AnalyticsPrimitive> => {
  const out: Record<string, AnalyticsPrimitive> = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    out[key] = value;
  });
  return out;
};

export const trackEvent = (eventName: string, params: AnalyticsParams = {}): void => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;

  window.gtag('event', eventName, sanitizeParams(params));
};

export const initAnalytics = (
  measurementId: string = process.env.REACT_APP_GA_MEASUREMENT_ID || DEFAULT_GA_MEASUREMENT_ID
): void => {
  if (typeof window === 'undefined') return;
  if (!measurementId || didInitAnalytics) return;

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    // Google processes gtag commands as Arguments objects, not arrays.
    window.dataLayer?.push(arguments);
  };

  window.gtag('js', new Date());
  window.gtag('config', measurementId);

  if (!document.getElementById(GA_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
  }

  didInitAnalytics = true;
};

